/* Cart drawer API. Extracted from layout/theme.liquid so it ships as a cached
   asset instead of ~13KB of inline JS on every page. Contains no Liquid. */
// Base URL for Cart API (locale-aware per Shopify docs)
      function cartApiRoot() {
        return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '';
      }
      // Fetch fresh cart drawer HTML and update #CartDrawer (so add/remove reflect immediately)
      window.refreshCartDrawerContent = async function() {
        var cartDrawer = document.getElementById('CartDrawer');
        if (!cartDrawer) return;
        var root = cartApiRoot();
        var html = null;
        try {
          // Prefer section_id: returns raw HTML in cart context (most reliable)
          var sectionRes = await fetch(root + 'cart?section_id=cart-drawer&_=' + Date.now(), { cache: 'no-store', credentials: 'same-origin' });
          if (sectionRes.ok) {
            var text = await sectionRes.text();
            if (text && text.trim().length > 0) html = text;
          }
          // Fallback: sections param returns JSON
          if (!html) {
            var sectionsRes = await fetch(root + 'cart?sections=cart-drawer&_=' + Date.now(), { cache: 'no-store', credentials: 'same-origin' });
            if (sectionsRes.ok) {
              var ct = sectionsRes.headers.get('Content-Type') || '';
              if (ct.indexOf('application/json') !== -1) {
                var data = await sectionsRes.json();
                html = data && (data['cart-drawer'] || (data.sections && data.sections['cart-drawer']));
                if (!html && data && typeof data === 'object') {
                  var keys = Object.keys(data);
                  for (var i = 0; i < keys.length; i++) {
                    if (data[keys[i]] && typeof data[keys[i]] === 'string') { html = data[keys[i]]; break; }
                  }
                }
              }
            }
          }
          if (!html) return;
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var inner = doc.querySelector('#CartDrawer') || doc.querySelector('[id*="cart-drawer"] #CartDrawer') || doc.querySelector('#shopify-section-cart-drawer #CartDrawer') || doc.body.firstElementChild;
          if (inner) cartDrawer.innerHTML = inner.innerHTML;
          fixCartDrawerCheckoutLink();
          removeOrphanGifts();
        } catch (e) {
          console.warn('Cart drawer refresh error:', e);
        }
      };
      // Free bundle gifts whose parent line is gone: the drawer lists their keys in
      // [data-orphan-gifts]; zero them so they can't ride into checkout unseen.
      var orphanBusy = false;
      async function removeOrphanGifts() {
        var el = document.querySelector('#CartDrawer [data-orphan-gifts]');
        if (!el || orphanBusy) return;
        var updates = {};
        el.getAttribute('data-orphan-gifts').split(',').filter(Boolean).forEach(function(k) { updates[k] = 0; });
        if (!Object.keys(updates).length) return;
        orphanBusy = true;
        try {
          var res = await fetch(cartApiRoot() + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates }),
            credentials: 'same-origin'
          });
          if (res.ok) {
            if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
            await window.refreshCartDrawerContent();
            window.dispatchEvent(new CustomEvent('cart:updated'));
          }
        } catch (e) {} finally { orphanBusy = false; }
      }
      window.removeOrphanGifts = removeOrphanGifts;

      // Ensure checkout link in drawer always has valid href (Section API can return empty)
      function fixCartDrawerCheckoutLink() {
        var drawer = document.getElementById('CartDrawer');
        if (!drawer) return;
        var root = cartApiRoot();
        var checkoutUrl = (root ? root + 'checkout' : '/checkout').replace(/\/\/checkout/, '/checkout');
        var link = drawer.querySelector('a[data-cart-checkout-link]');
        // Discount codes now live on the cart itself, so checkout picks them up with no
        // ?discount= on the URL.
        if (link) link.setAttribute('href', checkoutUrl);
      }

      // Remove item from cart via AJAX and refresh drawer (no page navigation)
      window.refreshCartDrawerRemoveLine = async function(event, line, bundleId, keys) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        var root = cartApiRoot();
        try {
          // Preferred path: the drawer renders the exact line-item keys (parent + any bundle
          // gifts), so removal never needs a GET /cart.js — that request is blocked by the
          // storefront's analytics wrapper and used to break removal entirely.
          if (keys) {
            var keyList = String(keys).split(',').filter(Boolean);
            var updates = {};
            keyList.forEach(function(k) { updates[k] = 0; });
            var keyRes = await fetch(root + 'cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: updates }),
              credentials: 'same-origin'
            });
            if (!keyRes.ok) { console.warn('Cart remove failed', keyRes.status); return; }
          } else if (bundleId) {
            // Fallback: look the bundle lines up (only reachable if data-keys is missing)
            var cartNow = await (await fetch(root + 'cart.js', { credentials: 'same-origin' })).json();
            var updates = {};
            (cartNow.items || []).forEach(function(it) {
              var bid = it.properties && it.properties._bundle_id;
              if (bid && bid === bundleId) updates[it.key] = 0;
            });
            var upRes = await fetch(root + 'cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: updates }),
              credentials: 'same-origin'
            });
            if (!upRes.ok) { console.warn('Bundle remove failed'); return; }
          } else {
            var changeRes = await fetch(root + 'cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ line: parseInt(line, 10), quantity: 0 }),
              credentials: 'same-origin'
            });
            if (!changeRes.ok) { console.warn('Cart change failed'); return; }
          }
          // Update the drawer immediately — refreshCartDrawerContent is a GET and can be
          // blocked by the storefront analytics wrapper, which previously left the removed
          // row on screen and made removal look broken.
          try {
            var btnEl = event && event.target && event.target.closest ? event.target.closest('.cart-drawer-remove-line') : null;
            var row = btnEl ? btnEl.closest('.cd-item') : null;
            if (row) {
              var sib = row.nextElementSibling;
              if (sib && sib.classList && sib.classList.contains('cd-bundle')) sib.remove();
              row.remove();
            }
            var drawerEl = document.getElementById('CartDrawer');
            if (drawerEl && !drawerEl.querySelector('.cd-item')) {
              var body = drawerEl.querySelector('.cd__body');
              if (body) body.innerHTML = '<div class="cd__empty"><p>Your cart is empty</p><a href="/collections/all">Continue shopping</a></div>';
              var foot = drawerEl.querySelector('.cd__foot');
              if (foot) foot.style.display = 'none';
            }
          } catch (e) {}
          try { if (window.refreshCartDrawerContent) await window.refreshCartDrawerContent(); } catch (e) {}
          var count = null;
          try { var cr = await fetch(root + 'cart.js', { credentials: 'same-origin' }); if (cr.ok) count = (await cr.json()).item_count; } catch (e) {}
          window.dispatchEvent(new CustomEvent('cart:updated', { detail: { itemCount: count } }));
        } catch (e) {
          console.warn('Cart drawer remove error:', e);
        }
      };

      // Vanilla JS add-to-cart per Shopify Cart API: JSON body, locale-aware URL, credentials, bundled sections
      // https://shopify.dev/docs/api/ajax/reference/cart
      function handleAddToCartSubmit(e) {
        var form = e.target;
        if (form.tagName !== 'FORM' || !form.action || form.action.indexOf('/cart/add') === -1) return;
        if (!form.classList.contains('js-ajax-add-to-cart')) return;
        e.preventDefault();
        var idInput = form.querySelector('input[name="id"]');
        var variantId = idInput ? (idInput.value || '').trim() : '';
        if (!variantId || variantId === '0') {
          alert('Please select a variant before adding to cart.');
          return;
        }
        var isBuyNow = form.getAttribute('data-buy-now') === 'true';
        var root = cartApiRoot();
        var payload = {
          items: [{ id: parseInt(variantId, 10), quantity: 1 }],
          sections: 'cart-drawer',
          sections_url: '/cart'
        };
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
          credentials: 'same-origin'
        })
          .then(function(res) {
            return res.json().then(function(data) {
              if (!res.ok) throw data;
              return data;
            });
          })
          .then(function(data) {
            var itemCount = (data && data.item_count) || (data && data.items && data.items.length);
            if (itemCount === undefined) {
              return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function(r) { return r.json(); }).then(function(cart) {
                return { item_count: cart.item_count, sections: data.sections };
              });
            }
            return Promise.resolve({ item_count: itemCount, sections: data.sections });
          })
          .then(function(data) {
            var cart = data;
            var count = cart.item_count;
            if (count === undefined && cart.items) count = cart.items.length;
            var badges = document.querySelectorAll('.header-cart-trigger .absolute');
            if (badges.length) {
              badges.forEach(function(b) {
                b.textContent = count || 0;
                b.style.display = (count > 0) ? 'flex' : 'none';
              });
            } else if (count > 0) {
              document.querySelectorAll('.header-cart-trigger').forEach(function(cartBtn) {
                var b = document.createElement('span');
                b.className = 'absolute -top-2 -right-2 w-5 h-5 rounded-full bg-red-600 text-white text-[10px] font-bold flex items-center justify-center leading-none';
                b.textContent = count;
                cartBtn.appendChild(b);
              });
            }
            if (isBuyNow) {
              window.location.href = (root || '/') + 'checkout';
              return;
            }
            var drawer = document.getElementById('CartDrawer');
            var openDrawer = function() {
              if (drawer) {
                drawer.classList.remove('translate-x-full');
                drawer.setAttribute('aria-hidden', 'false');
              }
            };
            var sectionHtml = (cart.sections && (cart.sections['cart-drawer'] || cart.sections['cart_drawer'])) || null;
            if (!sectionHtml && cart.sections && typeof cart.sections === 'object') {
              var sectionKeys = Object.keys(cart.sections);
              for (var ki = 0; ki < sectionKeys.length; ki++) {
                if (cart.sections[sectionKeys[ki]]) { sectionHtml = cart.sections[sectionKeys[ki]]; break; }
              }
            }
            if (drawer && sectionHtml) {
              var parser = new DOMParser();
              var doc = parser.parseFromString(sectionHtml, 'text/html');
              var inner = doc.querySelector('#CartDrawer') || doc.querySelector('[id*="cart-drawer"] #CartDrawer') || doc.body.firstElementChild;
              if (inner) {
                drawer.innerHTML = inner.innerHTML;
                fixCartDrawerCheckoutLink();
              }
              openDrawer();
            } else if (drawer && window.refreshCartDrawerContent) {
              window.refreshCartDrawerContent().then(openDrawer).catch(openDrawer);
            } else {
              openDrawer();
            }
          })
          .catch(function(err) {
            alert('Error adding to cart: ' + (err && err.description ? err.description : 'Please try again.'));
          });
      }
      document.body.addEventListener('submit', handleAddToCartSubmit, true);

      document.addEventListener('DOMContentLoaded', function() {
        fixCartDrawerCheckoutLink();
        var cartDrawer = document.getElementById('CartDrawer');
        var cartTriggers = document.querySelectorAll('.header-cart-trigger');

        if (cartDrawer && cartTriggers.length) {
          cartTriggers.forEach(function(btn) {
            btn.addEventListener('click', function() {
              cartDrawer.classList.remove('translate-x-full');
              cartDrawer.setAttribute('aria-hidden', 'false');
            });
          });
        }

        // Event delegation: remove buttons work even after drawer content is replaced
        if (cartDrawer) {
          cartDrawer.addEventListener('click', function(e) {
            var btn = e.target.closest('.cart-drawer-remove-line');
            if (!btn) return;
            e.preventDefault();
            e.stopPropagation();
            var line = btn.getAttribute('data-line');
            var bundleId = btn.getAttribute('data-bundle-id');
            var keys = btn.getAttribute('data-keys');
            window.refreshCartDrawerRemoveLine(e, line, bundleId || null, keys || null);
          });
        }

        // Calculate header height and add padding to main content
        function updateMainContentPadding() {
          var header = document.querySelector('header');
          var mainContent = document.getElementById('MainContent');
          
          if (header && mainContent) {
            var headerHeight = header.offsetHeight;
            mainContent.style.paddingTop = headerHeight + 'px';
          }
        }

        // Update on load
        updateMainContentPadding();
        removeOrphanGifts();

        // Update on resize (in case header height changes)
        window.addEventListener('resize', updateMainContentPadding);
      });
